/* eslint-disable react/no-unescaped-entities */
import { AppStyles } from '../../../assets/styles/AppStyles'
import { useTheme } from '../../../utils/ThemeColorContext'

import React from 'react'
import DefaultPage from '../DefaultPage'
import CheckInformationWrapper from '../CheckInformationWrapper'

function GenericDeclined() {

  const { color, isSmallScreen } = useTheme()

  return (
    <DefaultPage>
      <div className="h-full flex flex-col items-center justify-center space-y-10 ">
        <div className={"h-px"} />
        <CheckInformationWrapper img={null}>
          <div className="w-full space-y-8 md:space-y-10">
            <div className="flex flex-col items-center space-y-0 md:space-y-0 ">
              <h1
                style={
                  isSmallScreen
                    ? {
                        ...AppStyles.Title1,
                        color: color.Plum,
                      }
                    : {
                        ...AppStyles.LargeTitle2,
                        color: color.Plum,
                      }
                }
                className="text-center"
              >
                Sorry
              </h1>
              <h1
                style={
                  isSmallScreen
                    ? {
                        ...AppStyles.Title2,
                        color: color.Blurple,
                        paddingTop: '8px',
                      }
                    : {
                        ...AppStyles.Title1,
                        color: color.Blurple,
                        paddingTop: '8px',
                      }
                }
                className="text-center"
              >
                Unfortunately we can't offer<br/>you a loan at this time.
              </h1>
            </div>
          </div>
          <div className="flex flex-col w-full space-y-0 items-center">
            <div className="flex flex-col w-full items-center space-y-6">
              <div
                className="flex justify-center w-full rounded-[12px] mt-6"
                style={{
                  background: 'rgba(93, 28, 211, 0.05)',
                  padding: '20px 16px 16px 16px',
                }}
              >
                <span className="reapplyin"> You can reapply with Updraft in</span>
                <span className="days_90">
                  90 days
                </span>
              </div>
              <div className="h-px"/>
            </div>
          </div>
        </CheckInformationWrapper>
      </div>
    </DefaultPage>
  )
}

export default GenericDeclined
